export default __webpack_public_path__ + "static/media/learose3-1920w.5160bd5d.avif";